export const TOAST_HOST_ID = {
  SCRIPT: 'script-notifications',
  FOLDER_EXPLORER: 'explorer-notifications',
}

export const TOAST_ID = {
  SCRIPT_DISCONNECT: 'disconnect-warning',
}
